import { render, staticRenderFns } from "./DashboardBasic.vue?vue&type=template&id=dbc61a38&scoped=true"
import script from "./DashboardBasic.vue?vue&type=script&lang=js"
export * from "./DashboardBasic.vue?vue&type=script&lang=js"
import style0 from "./DashboardBasic.vue?vue&type=style&index=0&id=dbc61a38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc61a38",
  null
  
)

export default component.exports